import { Pause, Pencil, Play, RefreshCw, Trash2 } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { Alert } from "../../watchlist/types";

export type AlertAction = {
  key: string;
  Icon: LucideIcon;
  label: string;
  run: () => void;
  /** Destructive: tinted red wherever it is rendered. */
  danger?: boolean;
};

export type AlertHandlers = {
  onRunNow: () => void;
  onToggleEnabled: () => void;
  onRename: (title: string) => Promise<void>;
  onEdit: () => void;
  onDelete: () => void;
};

/**
 * The things that can be done to an alert. The list puts them in an overflow
 * menu and the detail view in its header, but they stay one set: an action
 * added here shows up in both.
 */
export const useAlertActions = (alert: Alert, handlers: AlertHandlers): AlertAction[] => {
  const { t } = useTranslation();

  return [
    {
      key: "run",
      Icon: RefreshCw,
      label: t("watchlist.run_now"),
      run: handlers.onRunNow,
    },
    {
      key: "toggle",
      Icon: alert.enabled ? Pause : Play,
      label: alert.enabled ? t("pause") : t("resume"),
      run: handlers.onToggleEnabled,
    },
    { key: "edit", Icon: Pencil, label: t("edit"), run: handlers.onEdit },
    {
      key: "delete",
      Icon: Trash2,
      label: t("delete"),
      run: handlers.onDelete,
      danger: true,
    },
  ];
};
